import { createFileRoute } from '@tanstack/react-router';
import { UnassignedResolutionPage } from './-components/UnassignedResolutionPage';
export const Route = createFileRoute('/_staff/salary-and-wages/_layout/settings/establishments/unassigned')({
  component: UnassignedResolutionPage
});